/**
 * Wraps the active screen with a flex-grow / overflow-hidden box so
 * each screen owns its own scroll. Screens use ``vz-scroll`` on their
 * inner content container to opt into the design's scrollbar styles.
 */

import type { ReactNode } from "react";

export function ScreenContainer({
  children,
}: {
  children: ReactNode;
}): JSX.Element {
  return (
    <div style={{ flex: 1, minHeight: 0, overflow: "hidden" }}>{children}</div>
  );
}
